import { render, staticRenderFns } from "./IbxSelectorExpand.vue?vue&type=template&id=165cc3de"
import script from "./IbxSelectorExpand.vue?vue&type=script&lang=js"
export * from "./IbxSelectorExpand.vue?vue&type=script&lang=js"
import style0 from "./IbxSelectorExpand.vue?vue&type=style&index=0&id=165cc3de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports